// @aide-description Filterable list of access groups, each showing the site it applies to, the permission level it grants and how many users it contains
import React from "react";
import { MaplesPage } from "components/pages";
import { ListGroups } from "features/Groups/ListGroups";

const GroupsListPage = () => {
  return (
    <MaplesPage headerItems={["Groups"]}>
      <ListGroups />
    </MaplesPage>
  );
};

export default GroupsListPage;
